import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./facades/facade.module').then(m => m.FacadeModule),
  },
  {
    path: 'auth/admin',
    loadChildren: () => import('./admin-auth/admin-auth.module').then(m => m.AdminAuthModule),
    canLoad: [AuthGuard],
    data: { needAuth: false },
  },
  { path: '**', redirectTo: '/events', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      scrollPositionRestoration: 'top', // Always scroll to top on route change
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
